
import { Bell } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { useNotifications } from "../hooks/useNotifications";
import { cn } from "@/lib/utils";

export function NotificationIcon() {
  const { notifications } = useNotifications();
  const unreadCount = notifications.filter(n => !n.read).length;
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link to="/notifications" className="relative inline-flex items-center justify-center rounded-md p-1.5 text-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            <Bell className="h-5 w-5" />
            {unreadCount > 0 && (
              <Badge 
                variant="destructive" 
                className={cn(
                  "absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-medium",
                  unreadCount > 9 ? "px-[3px]" : ""
                )}
              >
                {unreadCount > 99 ? "99+" : unreadCount}
              </Badge>
            )}
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          <p>{unreadCount > 0 ? `${unreadCount} unread notifications` : 'No new notifications'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
